import React from 'react'
// import EtUpdateUserImprintMissionClientComp from '@/features/userMagic/userImprint/EtUpdateUserImprintMissionClientComp'
import EtUpdateUserImprintMissionClientComp from '@/pages/home/web/userImprint/EtUpdateUserImprintMissionClientComp' //09 Aug 2025

import {
    XCircleIcon
  } from "@heroicons/react/24/solid"

const EtModalUpdateUserImprintMissionClient = ({isOpen, id, userId, userOrgId, triggeringUrl, onClose}) => {

  // First Created - 10 Jan 2025
  // Author - Atul Pandey
  // Inherited from EtModalCreateUserImprintGratitude
  // Updated - 09 Aug 2025 - switched the update comp location from @/features to @/pages
  
  // console.log('triggering url', triggeringUrl)

  if (!isOpen) return null


  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 z-70 flex justify-center items-start font-poppins overflow-y-auto p-4">
      <div className="bg-black p-5 rounded-lg shadow-lg shadow-black relative w-full max-w-6xl">
        <div
          className="absolute top-2 right-2 m-2 font-bold rounded-full cursor-pointer h-7 w-7 flex justify-center items-center"
          onClick={onClose}
        >
          <XCircleIcon className='text-orange-600 rounded-full hover:text-red-600 h-7 w-7'/>
        </div>
        <EtUpdateUserImprintMissionClientComp id={id} userId={userId} userOrgId={userOrgId} triggeringUrl={triggeringUrl} onClose={onClose}/>
      </div>
    </div>
  )
}

export default EtModalUpdateUserImprintMissionClient